import { useMutation } from '@tanstack/react-query';
import { orpc } from 'src/api/rpc/client';

const useSyncOrderConfirmation = (
  orderConfirmationId: string,
  onSuccess?: () => void,
) => {
  return useMutation({
    mutationFn: (variables?: { force?: boolean }) =>
      orpc.edi.orderConfirmations.sync.call({
        orderConfirmationId,
        ...(variables?.force && { force: true }),
      }),
    onSuccess,
  });
};

export default useSyncOrderConfirmation;
